import { Capacitor } from '@capacitor/core';
import classnames from 'classnames';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle.jsx';

import { AppContext } from '../AppContext';

function filterClick(e) {
	e?.preventDefault?.();
	e?.stopPropagation?.();
}

const ProductClassNames = {
	'com.jdsoftwarellc.ginrummy.removeads': 'buttonRemoveAds',
};

const Store = () => {
	const { t } = useTranslation();
	const app = React.useContext(AppContext);
	const [products, setProducts] = React.useState([]);

	React.useEffect(() => {
		if (!app.iap) {
			return;
		}

		(async () => {
			const newProducts = await app.iap.getCatalog();
			setProducts(newProducts);
		})();
	}, [app.iap, app.userdata?.removeAds]);

	const handleBuyClick = React.useCallback((e, item) => {
		filterClick(e);
		console.info('clicked buy, buying', item);
		app.iap.buy(item);
	}, [app.iap]);

	const handleRejectClick = React.useCallback((e, item) => {
		filterClick(e);
		console.info(`tried to buy ${item} but already owned`);
	}, []);

	const handleRestoreButton = React.useCallback((e) => {
		filterClick(e);
		console.info('clicked restore');
		app.iap.restore();
	}, [app.iap]);

	//The restore link is really only useful on iOS
	//On android, it just forwards to getPurchases
	const restoreLink = React.useMemo(() => {
		if (Capacitor.getPlatform() !== 'ios') {
			return null;
		}

		return (
			<li className="restorePurchaseHolder">
				<a href="#" onClick={handleRestoreButton}>
					Restore purchases
				</a>
			</li>
		);
	}, [handleRestoreButton]);

	const productList = React.useMemo(() => {
		const list = [];

		for (const product of products) {
			if (!product.canPurchase) {
				continue;
			}

			const clickHandler = product.owned ? handleRejectClick : handleBuyClick;
			list.push(
				<li key={product.productId}>
					<a
						className={classnames('button', ProductClassNames[product.productId], product.owned && 'owned')}
						href="#"
						onClick={(e) => clickHandler(e, product.productId)}
					>
						{t(product.title)}
					</a>
				</li>,
			);
		}

		return list;
	}, [handleBuyClick, handleRejectClick, products, t]);

	return (

		<div id="Achievements1" className="page1 noAnimate">
			<div className="wrapper">
				<PageTitle className="paddingTop50">
					<h1>{t('Store')}</h1>
				</PageTitle>

				<ul className="buttonList storeList" >
					{productList}
					{restoreLink}
				</ul>

			</div>
		</div>
	);
};

export default Store;
